import React from 'react';
import { Check, ExternalLink, Trash2 } from 'lucide-react';
import { Link } from 'react-router-dom';

const ChecklistItem = ({ task, checked, onToggle, onRemove }) => (
  <li
    className={`group flex items-start gap-4 rounded-xl px-4 py-3.5 transition-colors ${checked ? 'bg-[#FBF3F5]' : 'hover:bg-[#FAF9F7]'}`}
    data-testid={`checklist-item-${task.id}`}
  >
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      onClick={onToggle}
      className={`mt-0.5 shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all duration-300 ${
        checked ? 'border-[#DE92A9] bg-[#DE92A9] scale-105' : 'border-[#D9CFC7] bg-white hover:border-[#DE92A9]'
      }`}
      data-testid={`checklist-item-checkbox-${task.id}`}
    >
      {checked && <Check size={14} className="text-white" strokeWidth={3} />}
    </button>

    <div className="flex-1 min-w-0">
      <button
        type="button"
        onClick={onToggle}
        className={`text-left text-sm md:text-base leading-snug transition-colors ${
          checked ? 'line-through text-[#A0978A]' : 'text-[#2C2C2C]'
        }`}
        data-testid={`checklist-item-label-${task.id}`}
      >
        {task.label}
      </button>
      {task.hint && !checked && (
        <p className="text-xs mt-1 leading-relaxed" style={{ color: '#757B7F' }}>{task.hint}</p>
      )}
      {task.link && !checked && (
        <Link
          to={task.link}
          className="inline-flex items-center gap-1 text-xs mt-1.5 font-medium underline underline-offset-2 hover:text-[#C9758F] transition-colors"
          style={{ color: '#DE92A9' }}
          data-testid={`checklist-item-link-${task.id}`}
        >
          {task.linkLabel || 'Read more'}
          <ExternalLink size={11} />
        </Link>
      )}
    </div>

    {task.custom && (
      <button
        type="button"
        onClick={onRemove}
        aria-label="Remove task"
        className="shrink-0 p-1.5 rounded-full text-[#C0B9B0] opacity-0 group-hover:opacity-100 focus:opacity-100 hover:text-[#C9758F] hover:bg-white transition-all"
        data-testid={`checklist-remove-${task.id}`}
      >
        <Trash2 size={14} />
      </button>
    )}
  </li>
);

export default ChecklistItem;
